var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg451(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "55px",
    height: "34px",
    viewBox: "0 0 60 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set-Strategy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Strategy-Final-|-Player-Added-+-Player's-List-(After-Dragging)-(Desktop)",
    transform: "translate(-121.000000, -306.000000)",
    fill: "#B2B2B2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34-Copy-4",
    transform: "translate(151.000000, 323.000000) rotate(-180.000000) translate(-151.000000, -323.000000) translate(121.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 31,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 4,
    cy: 17,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 17,
    cy: 17,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 30,
    cy: 17,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 43,
    cy: 17,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 56,
    cy: 17,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 11,
    cy: 30,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 24,
    cy: 30,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 37,
    cy: 30,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 50,
    cy: 30,
    r: 4
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg451);
export default __webpack_public_path__ + "static/media/4-5-1.1eaef1effac62a9d5f125ecc0bb9d028.svg";
export { ForwardRef as ReactComponent };